import { render, staticRenderFns } from "./VerifyEmailBanner.vue?vue&type=template&id=f4d3e318&scoped=true"
import script from "./VerifyEmailBanner.vue?vue&type=script&lang=js"
export * from "./VerifyEmailBanner.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailBanner.vue?vue&type=style&index=0&id=f4d3e318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d3e318",
  null
  
)

export default component.exports